import Store from '@/store';
import PTC_Pedidos from '@/api/PTC/PTC_Pedidos.client';
import Notifier from '@/libs/Notifier';
import store from '@/store';

export default class PTC_PedidosService {
  constructor() {
    this.client = new PTC_Pedidos();
    this.store = Store;
    this.notify = new Notifier();
  }

  buildQuery(query = {}) {
    // Escopo de cliente é decidido no backend pelo usuário e perfil ativos.
    // localStorage nunca funciona como fronteira de autorização.
    return query;
  }

  async retornaPedidos(query = {}) {
    try {
      this.store.commit('PTC_PedidosClient/SET_IS_LOADING', true);
      const queryWithClient = this.buildQuery(query);
      const data = await this.client.retornaPedidos(queryWithClient);
      this.store.commit('PTC_PedidosClient/SET_PEDIDOS', data);
      this.store.commit('PTC_PedidosClient/SET_FILTROS', { ...queryWithClient });
      return data;
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_PedidosClient/SET_IS_LOADING', false);
    }
  }

  async contarBackorders(query = {}) {
    return this.store.dispatch('PTC_PedidosClient/contarBackorders', this.buildQuery(query));
  }

  async retornaPedidoDetalhe(pedidoid) {
    try {
      this.store.commit('PTC_PedidosClient/SET_IS_LOADING', true);
      const data = await this.client.retornaPedidoDetalhe(pedidoid);
      console.log('pedido', data.pedido[0]);
      this.store.commit('PTC_PedidosClient/SET_DETALHES_PEDIDO', data.pedido[0]);
      this.store.commit('PTC_PedidosClient/ITENS_PEDIDO', data.pedidoItens);
      this.store.commit('PTC_PedidosClient/TOTAL_PEDIDO', data.totalPedido);
      return data;
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_PedidosClient/SET_IS_LOADING', false);
    }
  }

  async exportarPedidos(query = {}) {
    try {
      // Dedicated, unbounded XLSX export. Never use the capped list endpoint
      // or alter the current list, filters, pagination or shared loading.
      const filters = { ...query };
      ['page', 'pageSize', 'perPage', 'currentPage', 'limit', 'offset', 'contagemBackorders'].forEach(key => {
        delete filters[key];
      });
      return await this.client.exportarPedidos(this.buildQuery(filters));
    } catch (error) {
      throw this.notify.error(error.message);
    }
  }
}
